import React from 'react';
import { FilterDefinition, DateFilter } from '../@types';

export interface FilterMap {
  [partitionId: 'default' | string]: Record<
    string,
    FilterDefinition | Array<FilterDefinition>
  >;
}

export interface IFilterContext {
  filters: FilterMap;
  setFilters: React.Dispatch<React.SetStateAction<FilterMap>>;
  updateDateFilterPersistance: (filter: DateFilter) => void;
  dateFilterMode?: 'date' | 'month' | 'year';
  persist?: boolean;
}

const filterContext = React.createContext<IFilterContext>({
  filters: {},
  setFilters: () => null,
  updateDateFilterPersistance: () => null,
  persist: undefined,
});

export default filterContext;
